<template>
	<div>
		<div v-for="file in currentComplianceFiles" :key="file.id">
			<div class="control">
				<div class="columns">
						<div class="column is-12">
							<span
									class="formfield view-file"
									@click="showComplianceFile(file)"
									v-html="truncateFilename(file.filename)"
							></span>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { truncateFilename } from '@/utils/filename'

export default {
	data(){
		return {}
	},
	computed: {
		...mapState('compliance', {
			currentComplianceFiles: state => state.currentComplianceFiles
		})
	},
	methods: {
		truncateFilename,
		showComplianceFile(file) {
				VueStore.dispatch("compliance/setVariable", {
						key: "selectedFile",
						value: file,
				});
				VueStore.dispatch("notify/setVariable", {
						key: "viewComplianceFilesModal",
						value: true,
				});
		},
	}
}
</script>
